export default __webpack_public_path__ + "static/media/photo--sm--huda-4.21193cf6.jpg";